<div *ngIf="useInlineList" class="gl-inline-lookup full-width">
	<label class="gl-inline-label" for="gl-inline-filter">{{ label }}</label>
	<input
		id="gl-inline-filter"
		type="text"
		class="gl-inline-input"
		[formControl]="filterText"
		autocomplete="off"
		appSelectOnFocus
	/>
	<p class="gl-inline-hint" *ngIf="!filterText.value && (allglaccounts?.length || 0) > maxInlineResults">
		Showing first {{ maxInlineResults }} accounts. Type code or name to narrow.
	</p>
	<div class="gl-inline-list" *ngIf="inlineList?.length">
		<button type="button" class="gl-inline-option" *ngFor="let account of inlineList" (click)="selectInlineAccount(account)">
			<span class="gl-inline-code">{{ account.accountcode }}</span>
			<span class="gl-inline-meta" *ngIf="account.group"><b>{{ account.group }}</b>: {{ account.accountname }}</span>
			<span class="gl-inline-meta" *ngIf="!account.group">{{ account.accountname }}</span>
		</button>
	</div>
	<div class="gl-inline-empty" *ngIf="allglaccounts?.length && !inlineList?.length && filterText.value">
		No matches. Try another code or name.
	</div>
	<div class="gl-inline-empty" *ngIf="!allglaccounts?.length">Loading accounts…</div>
</div>

<mat-form-field *ngIf="!useInlineList" class="full-width" appearance="outline">
	<mat-label>{{ label }}</mat-label>
	<input type="text" #glcharge matInput [formControl]="glsearch" [matAutocomplete]="gls" appSelectOnFocus>
	<mat-autocomplete #gls="matAutocomplete" (optionSelected)="addGl($event)" [displayWith]="displayFn">
		<mat-option *ngFor="let account of glaccounts" [value]="account">
			<ng-container *ngIf="account.group"><b>{{ account.group }}</b>: </ng-container>{{ account.accountcode }} {{ account.accountname }}
		</mat-option>
	</mat-autocomplete>
</mat-form-field>
